export default __webpack_public_path__ + "static/media/devography.7b543a82.png";